<script setup lang="ts">
    import Button from '@/shared/ui/Button/Button.vue';
    import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/shared/ui/Dialog';
    import { useAuthDialogStore } from '../auth-dialog-store';

    const store = useAuthDialogStore();
    const { t } = useI18n();
</script>

<template>
    <DialogHeader>
        <DialogTitle>{{ t('LINK_SENT') }}</DialogTitle>
        <DialogDescription class="sr-only">{{ t('DESCRIPTION') }}</DialogDescription>
    </DialogHeader>
    <div class="py-5">
        {{ t('EMAIL_SUBMITTED', { email: store.resetPasswordEmail }) }}
    </div>
    <DialogFooter>
        <Button
            variant="secondary"
            @click="store.modalState = 'login'"
        >
            {{ t('BACK_TO_LOGIN') }}
        </Button>
    </DialogFooter>
</template>

<i18n lang="yaml">
en:
    LINK_SENT: Reset link sent
    BACK_TO_LOGIN: Back to login
    EMAIL_SUBMITTED: 'We have sent a link to {email} to reset your password.'
    DESCRIPTION: Check your email for password reset link
nl:
    LINK_SENT: Resetlink verzonden
    BACK_TO_LOGIN: Terug naar de login
    EMAIL_SUBMITTED: 'We hebben een link verstuurd naar {email} om je wachtwoord te resetten.'
    DESCRIPTION: Controleer uw e-mail voor de link om uw wachtwoord opnieuw in te stellen.
</i18n>
